<template>
    <card :loading="loading" size="sm">
        <p
            class="align-center mb-2 flex text-sm font-medium text-gray-600 dark:text-gray-400"
        >
            {{ metric.name }}
            <span
                v-if="isFlagged"
                class="ml-auto rounded-full px-2 text-xs font-semibold"
                :class="flagClass"
            >
                ⚑
            </span>
        </p>
        <p
            class="flex text-lg font-semibold"
            :class="rateClass(metric.tpn)"
        >
            TPN: {{ metric.tpn }}%
        </p>
        <p
            class="flex text-lg font-semibold"
            :class="rateClass(metric.tpv)"
        >
            TPV: {{ metric.tpv }}%
        </p>
    </card>
</template>

<script>
import Card from "../../layouts/Card.vue";

export default {
    components: { Card },
    props: ["metric", "loading"],
    computed: {
        isFlagged() {
            return (
                Number(this.metric.tpn) > 1 || Number(this.metric.tpv) > 1
            );
        },
        flagClass() {
            const worst = Math.max(
                Number(this.metric.tpn) || 0,
                Number(this.metric.tpv) || 0,
            );

            return worst >= 1.5
                ? "bg-red-100 text-red-600 dark:bg-red-900 dark:text-red-300"
                : "bg-amber-100 text-amber-600 dark:bg-amber-900 dark:text-amber-300";
        },
    },
    methods: {
        rateClass(value) {
            const rate = Number(value) || 0;

            if (rate >= 1.5) {
                return "text-red-600 dark:text-red-400";
            }

            if (rate > 1) {
                return "text-amber-600 dark:text-amber-400";
            }

            return "text-white-100 dark:text-gray-200";
        },
    },
};
</script>
